import { render, staticRenderFns } from "./BusinessAnnualReturnsEscalatedFile.vue?vue&type=template&id=7228775e&scoped=true&"
import script from "./BusinessAnnualReturnsEscalatedFile.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsEscalatedFile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnsEscalatedFile.vue?vue&type=style&index=0&id=7228775e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228775e",
  null
  
)

export default component.exports